
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-masters/curriculum",
      function () {
        return require("private-next-pages/growth-masters/curriculum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/growth-masters/curriculum"])
      });
    }
  